import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//styles
import './login.styl';
import 'bootstrap/dist/css/bootstrap.css';
//text
import { text, signup } from '../input-text/en/login_page';
//config
const baseUrl = require('Config').baseUrl;

class Login extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      email: '',
      password: '',
      popupText: 'Just a moment...',
    }
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({popupText: 'Just a moment...'});

    const url = `${baseUrl}/users/auth`;

    axios.post(url, {
    	email: this.state.email,
    	password: this.state.password
    })
    .then(response => {
      let token = response.data.token;
      this.props.sendToken(token);
    })
    .catch(err => {
      this.setState({popupText: "Incorrect email or password"});
    });
  }

  popup = () => {
    return (
      <Tooltip placement="right" className="in" id="tooltip-top">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  render(){
    return (
      <div className='login-page'>
        <SimpleContainer color='dark' containerClass='form-container padded-container'>
          <div className='login-form-wrapper'>
            <h1 className='login-page__title'>{text._title}</h1>
            <form className="login-page__form" onSubmit={ this.submitForm }>
              <div className="row">
                <div className="col-sm-6">
                  <div className="login-page__form__input-field">
                    <label htmlFor="email" className='form-text'>{text._email}<sup>*</sup></label>
                    <input id="email" type='email' name='email' className='input email' placeholder='example@company.com' value={this.state.email} onChange={this.inputChange}/>
                  </div>
                </div>
                <div className="col-sm-6">
                 <div className="login-page__form__input-field">
                    <label htmlFor="password" className='form-text'>{text._password}<sup>*</sup></label>
                    <input id="password" type='password' name='password' className='input password' value={this.state.password} onChange={this.inputChange}/>
                  </div>
                </div>
              </div>
              <div className="login-page__form__actions">
                <OverlayTrigger className='form-overlay' trigger={'focus'} placement="bottom" overlay={this.popup()}>
                  <button type="submit" className="button">{text._submit}</button>
                </OverlayTrigger>
              </div>
            </form>
          <h2 className='forgot-pass-text'><Link to='/login/recover'>Forgot password?</Link></h2>
          </div>
        </SimpleContainer>
          {this.props.children}
        <SimpleContainer color='white' containerClass='signup-strip padded-container'>
          <h1>{signup._title}</h1>
          <p>{signup._body}</p>
          <Link to='/signup/' className="button">Sign up now</Link>
        </SimpleContainer>
      </div>
    );
  }
};

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login.js